var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useId, useMemo, useState } from 'react';
import { FieldType } from './types';
import { fieldConverters } from './fieldConverter';
import FieldBuilder, { SelectFieldBuilder } from './FieldBuilder';
import useFormPersistence from './Persist/createFormPersist';
export var useFormConfig = function (config, options) {
    var _a, _b, _c, _d, _e;
    if (options === void 0) { options = {}; }
    var id = useId();
    var formId = (_a = options.id) !== null && _a !== void 0 ? _a : id;
    var builder = {
        input: function (value) {
            return new FieldBuilder(FieldType.INPUT, value, '');
        },
        check: function (value) {
            return new FieldBuilder(FieldType.CHECK, value, false);
        },
        select: function (value, values) {
            return new SelectFieldBuilder(value, values);
        }
    };
    var _f = useState(config(builder)), formConfig = _f[0], setFormConfig = _f[1];
    var formPersistence = useFormPersistence(formId);
    var defaults = {
        required: (_b = options.required) !== null && _b !== void 0 ? _b : false,
        persistURL: (_c = options.persistURL) !== null && _c !== void 0 ? _c : false,
        showErrors: (_d = options.showErrors) !== null && _d !== void 0 ? _d : false,
        persistStore: (_e = options.persistStore) !== null && _e !== void 0 ? _e : false,
        valueConverter: function (type) {
            if (type === FieldType.CHECK)
                return fieldConverters.boolean;
            return fieldConverters.default;
        }
    };
    var _g = useState(Object.keys(formConfig).reduce(function (prev, k) {
        var _a;
        var key = k;
        return __assign(__assign({}, prev), (_a = {}, _a[key] = formConfig[key].build(key, defaults), _a));
    }, {})), fields = _g[0], setFields = _g[1];
    var initialValues = useMemo(function () { return formPersistence.load(fields, setFields); }, []);
    var setShowErrors = function (keys, showErrors) {
        setFields(function (prev) {
            var newFields = __assign({}, prev);
            keys.forEach(function (key) { return newFields[key].showErrors = showErrors; });
            return newFields;
        });
    };
    var setTouched = function (keys, touched) {
        if (touched === void 0) { touched = true; }
        setFields(function (prev) {
            var newFields = __assign({}, prev);
            keys.forEach(function (key) { return newFields[key].touched = touched; });
            return newFields;
        });
    };
    var setTouchedAll = function (touched) {
        setTouched(Object.keys(fields), touched);
    };
    return useMemo(function () {
        return {
            id: formId,
            fields: fields,
            initialValues: initialValues,
            keys: Object.keys(fields),
            setShowErrors: setShowErrors,
            setTouched: setTouched,
            setTouchedAll: setTouchedAll,
        };
    }, [fields]);
};
